import { DoneOutline } from "@mui/icons-material";
import React from "react";
import * as msg from "utils/constants/messages";

const SaveMessage = (props) => {
    return <div className="icon-text">
        <DoneOutline style={{ color: "#27AE60" }} />
        <p style={{ marginLeft: "10px" }}>{msg.data_save}</p>
    </div>
}

export default SaveMessage;